import { useState } from 'react'
import { useAuth } from 'ict24h-themes-react'
import {
  ProjectMemberEntity,
  CreateProjectMemberInput,
} from '../../../../../../../server-api-hrm.type'
import commonRequestHandler from '../../../../../../../utils/common-request-handler'
import requestErrorHandler from '../../../../../../../utils/request-error-handler'
import { addProjectMember } from '../project-member.service'

type RequestFailType = 'SERVER' | 'RESOURCE' | 'OTHER'

type Params = {
  onFinish?: (_res: ProjectMemberEntity) => void
  onFail?: (_failType: RequestFailType) => void
  customRequestHandler?: boolean
}

const useCreateProjectMember = (params: Params = {}) => {
  const { token } = useAuth()

  const [loading, setLoading] = useState(false)

  const handleCreate = async (
    body: CreateProjectMemberInput,
    localHandler: Params = {}
  ) => {
    const onFinish = localHandler?.onFinish || params.onFinish
    const onFail = localHandler?.onFail || params.onFail
    const customRequestHandler =
      localHandler?.customRequestHandler ?? params.customRequestHandler

    const requestHandler = customRequestHandler
      ? requestErrorHandler
      : commonRequestHandler

    setLoading(true)
    const res = await addProjectMember(token, body)
    setLoading(false)
    if (!res) {
      if (typeof onFail === 'function') onFail('OTHER')
      return
    }
    requestHandler({
      status: res?.status,
      action: 'mutate',
      onSuccess: () => {
        if (typeof onFinish === 'function') onFinish(res.data)
      },
      onResourceFail: () => {
        if (typeof onFail === 'function') onFail('RESOURCE')
      },
      onServerFail: () => {
        if (typeof onFail === 'function') onFail('SERVER')
      },
    })
  }

  return {
    loading,
    handleCreate,
  }
}

export default useCreateProjectMember
